import { useContext } from 'react';
import { QuizContext } from '../quiz-provider';

export function useQuizContext() {
  const ctx = useContext(QuizContext);

  if (!ctx) {
    throw new Error('Unknown QuizContext');
  }

  return ctx;
}
